<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="model.id ? '编辑' : (pageType ? '新建一级' : '新建')"
      class="customer-edit"
      width="500px"
      top="5vh"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :model="model"
        :rules="ruleValidate"
        class="form"
        label-width="80px">
      <el-form-item label="类别名称" prop="name">
        <el-input v-model="model.name" placeholder="请输入" @change="change"/>
      </el-form-item>
      <el-form-item label="模板选择">
        <el-input v-model="model.templateName" readonly placeholder="选择">
          <el-button
              slot="append"
              icon="el-icon-search"
              @click="$refs.selectTemplate.open()"/>
        </el-input>
        <product-introduction-template-select ref="selectTemplate" @select="onSelectTemplate"/>
      </el-form-item>
      <el-table :data="tableData">
        <el-table-column type="index" width="120" align="center" label="显示顺序"/>
        <el-table-column prop="name" align="center" label="分组名称"/>
        <el-table-column label="排序" width="80" align="center">
          <template slot-scope="scope">
            <el-button
                size="mini"
                :disabled="scope.$index === 0"
                icon="el-icon-caret-top"
                @click="handleUp(scope.$index)"/>
            <br>
            <el-button
                size="mini"
                :disabled="scope.$index === tableData.length - 1"
                icon="el-icon-caret-bottom"
                style="margin-top: 5px"
                @click="handleDown(scope.$index)"/>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible=false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit1">保存</el-button>
    </span>
  </el-dialog>
</template>
<script>
  import ProductIntroductionTemplateSelect
    from "@/views/information/ProductIntroductionTemplate/ProductIntroductionTemplateSelect";
  export default {
    name:"ProductCategoryEdit",
    components: {ProductIntroductionTemplateSelect},
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        pageType: 0,
        tableData: [],
        model: {
          id: "",
          parentId: "",
          name: "",
          templateID: "",
          templateName: "",
          showIndexList:[],
          showIndex: 0,
        },
        ruleValidate: {
          name: {required: true, message: "不能为空", trigger: "blur"},
        },
      };
    },
    methods: {
      open(parentId, id, name,templateID,templateName,showIndexList, pageType) {
        console.log(parentId + "," + id + "," + name + "," + pageType);
        console.log(templateName);
        this.dialogVisible = true;
        this.model.id = id;
        this.model.parentId = parentId;
        this.model.name = name;
        this.model.templateID = templateID;
        this.model.templateName = templateName;
        this.tableData = showIndexList;
        this.pageType = pageType;
        if (id==null) {
          this.tableData.push(this.model);
        }
      },
      // getData() {
      //   this.$http
      //     .get("basic", `productCategories/${this.model.id}`)
      //     .then(resp => {
      //       this.tableData = resp.groups;
      //       console.log(this.tableData);
      //     });
      // },
      handleSubmit() {
        // let showIndexs=[];
        // let showIndex;
        // for (let item of this.tableData) {
        //   showIndexs.push(item.pkid);
        // }
        // showIndex = showIndexs.toString();
        this.model.showIndexList = this.tableData;
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            let category;
            if (this.model.id) {
              category = {
                id: this.model.id,
                name: this.model.name,
                templateID: this.model.templateID,
                showIndexList: this.model.showIndexList,
                parentId: this.model.parentId,
              };
            } else {
              category = {
                parentId: this.model.parentId,
                name: this.model.name,
                templateID: this.model.templateID,
                showIndexList: this.model.showIndexList,
              };
            }
            console.log(category);
            this.$http.save("basic", "productCategories", category)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$message.success("保存成功");
                this.$emit("save-success");
              })
              .catch(() => {
                this.submitLoading = false;
                this.$message.error("保存失败");
              });
          }
        });
      },
      handleSubmit1() {
        console.log(this.tableData);
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http.post("basic", "productCategories/showIndexList", this.tableData)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$message.success("保存成功");
                this.$emit("save-success");
              })
              .catch(() => {
                this.submitLoading = false;
                this.$message.error("保存失败");
              });
          }
        });
      },
      onSelectTemplate(row) {
        console.log(row);
        this.model.templateID = row.pkid;
        this.model.templateName = row.templateName;
        for (let i = 0; i <this.tableData.length ; i++) {
          if (this.tableData[i].id === this.model.id) {
            this.tableData[i].templateID = this.model.templateID;
          }
        }
        // this.getGroupsList(this.model.templateID);
      },
      change() {
        console.log(this.model);
        for (let i = 0; i <this.tableData.length ; i++) {
          if (this.tableData[i].id === this.model.id) {
            this.tableData[i].name = this.model.name;
          }
        }
      },
      // getGroupsList(id) {
      //   this.$http
      //     .get("basic", `productIntroductionTemplateGroups/getInitList/${id}`)
      //     .then(resp => {
      //       this.tableData = resp;
      //       console.log(this.tableData);
      //     });
      // },
      handleDown(index) {
        let temp = this.tableData[index];
        this.tableData.splice(index, 1);
        this.tableData.splice(index + 1, 0, temp);
      },
      handleUp(index) {
        let temp = this.tableData[index];
        this.tableData.splice(index, 1);
        this.tableData.splice(index - 1, 0, temp);
      },
    },
  };
</script>

<style scoped>

</style>
